module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-vehicle-slot"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 6
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('vehicle-slot-buttons', {
    attrs: {
      "vehicle": _vm.item
    }
  })], 1)], 1), _c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'vehicle-image'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'vehicle-id'
    },
    slot: "n2"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'vehicle-brand-and-lot'
    },
    slot: "n2"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'vehicle-plate'
    },
    slot: "n3"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'vehicle-category'
    },
    slot: "n4"
  }), (_vm.item.segment) ? _c('template', {
    slot: "n4"
  }, [_c('div', {
    staticClass: "field-segment"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Segment")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("SG" + _vm._s(_vm.item.segment.id) + " " + _vm._s(_vm.item.segment.name))])])]) : _vm._e(), _c('vehicle-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'vehicle-lot'
    },
    slot: "n5"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'vehicle-status'
    },
    slot: "n6"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'vehicle-additional-status'
    },
    slot: "n6"
  }), _c('div', {
    staticClass: "pl-2",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 2)], 1)]) : _vm._e(), (_vm.$is('oneLook')) ? _c('div', {
    staticClass: "one-look"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('router-link', {
    staticClass: "hollow button secondary small",
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.plate))])], 1) : _vm._e(), (_vm.$is('asset-management-list')) ? _c('div', {
    staticClass: "asset-management-list"
  }, [_c('div', {
    staticClass: "vehicle-id-and-name"
  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model) + " (V" + _vm._s(_vm.item.id) + ")")]), _c('vehicle-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'vehicle-plate'
    }
  })], 1) : _vm._e(), (_vm.$is('category-listing')) ? _c('div', {
    staticClass: "category-listing"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 4
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('vehicle-slot-buttons', {
    attrs: {
      "vehicle": _vm.item
    }
  })], 1)], 1), _c('img', {
    attrs: {
      "slot": "n1",
      "src": _vm.item.picture_external,
      "width": "100"
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'vehicle-id'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'vehicle-brand'
    },
    slot: "n2"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'vehicle-plate'
    },
    slot: "n2"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'vehicle-lot'
    },
    slot: "n3"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'vehicle-status'
    },
    slot: "n4"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1) : _vm._e(), (_vm.$is('fleet-map')) ? _c('div', {
    staticClass: "fleet-map"
  }, [_c('cardN', {
    attrs: {
      "showBullets": false,
      "showAction": true,
      "columns": 5
    }
  }, [_c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'vehicle-brand'
    },
    slot: "n1"
  }), _c('div', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": _vm.item.picture_external,
      "width": "100"
    }
  })])]), _c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'vehicle-lot'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'vehicle-plate'
    },
    slot: "n2"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'vehicle-fuel-type'
    },
    slot: "n3"
  }), _c('vehicle-status', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "showToolTip": false
    },
    slot: "n4"
  }), _c('vehicle-additional-status', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "showToolTip": false
    },
    slot: "n4"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1) : _vm._e(), (_vm.$is('compact-card')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }), _c('div', {
    staticClass: "columns shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-lg',
      "position": 'bottom'
    }
  }, [_c('vehicle-slot-buttons', {
    attrs: {
      "vehicle": _vm.item
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-12 large-6"
  }, [_c('h2', {
    staticClass: "vehicle-info"
  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('router-link', {
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.item.plate))])]), (_vm.item.parking_lot.id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'parkingLot',
        params: {
          id: _vm.item.parking_lot.id
        }
      }
    }
  }, [_c('h4', [_vm._v("PL" + _vm._s(_vm.item.parking_lot.id) + " " + _vm._s(_vm.item.parking_lot.name))])]) : _vm._e(), _c('h4', [_vm._v("VS" + _vm._s(_vm.item.slot_id) + " " + _vm._s(_vm.item.vehicle_slot_address))])], 1), _c('div', {
    staticClass: "column small-12 large-6"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.picture_external
    }
  }), _c('vehicle-status', {
    attrs: {
      "item": _vm.item
    }
  }), _c('div', {
    staticClass: "text-center"
  }, [_vm._t("default")], 2)], 1)])])]) : _vm._e(), (_vm.$is('vehicle-card')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('p', [_vm._v("Vehicle Information")]), _c('p', [_vm._v("CREATED AT " + _vm._s(_vm.item.created_at))]), (_vm.item.archived_at) ? _c('span', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("ARCHIVED AT " + _vm._s(_vm.item.archived_at))]), _c('p', [_vm._v("TIME IN ASSET " + _vm._s(_vm.$dateDifference(_vm.item.created_at, _vm.item.archived_at)))])]) : _vm._e()]), _c('div', {
    staticClass: "columns shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-lg',
      "position": 'bottom'
    }
  }, [_c('vehicle-slot-buttons', {
    attrs: {
      "vehicle": _vm.item
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-12"
  }, [_c('h2', {
    staticClass: "vehicle-info"
  }, [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('h2', [_vm._v(_vm._s(_vm.item.color) + " - " + _vm._s(_vm.item.category.name))]), _c('small', [_vm._v("VS" + _vm._s(_vm.item.slot_id) + " - " + _vm._s(_vm.item.slot_name) + " - " + _vm._s(_vm.item.vehicle_slot_address))]), (_vm.item.segment) ? _c('small', [_vm._v("SG" + _vm._s(_vm.item.segment.id) + " " + _vm._s(_vm.item.segment.name))]) : _vm._e(), _c('div', {
    staticClass: "test",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.picture_external
    }
  }), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'vehicle',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.item.plate))])])], 1), _c('vehicle-status', {
    attrs: {
      "item": _vm.item
    }
  }), _c('vehicle-additional-status', {
    attrs: {
      "item": _vm.item
    }
  })], 1)])])])]) : _vm._e(), (_vm.$is('parking-lot-assignment')) ? _c('div', {
    staticClass: "card card-section"
  }, [_c('span', [_vm._v("Parking lot assignment")]), (_vm.item.parking_lot.id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'parkingLot',
        params: {
          id: _vm.item.parking_lot.id
        }
      }
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.item.parking_lot.name))])]) : _vm._e()], 1) : _vm._e(), (_vm.$is('replace-listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 7
    }
  }, [_c('dropdown', {
    attrs: {
      "slot": "actionBullets",
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    },
    slot: "actionBullets"
  }, [_vm._t("actionBullets")], 2), _c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'vehicle-image'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'vehicle-id'
    },
    slot: "n2"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'vehicle-brand-and-lot'
    },
    slot: "n2"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'vehicle-plate'
    },
    slot: "n3"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'vehicle-fuel-type'
    },
    slot: "n4"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'vehicle-category'
    },
    slot: "n5"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'vehicle-lot'
    },
    slot: "n6"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n7",
      "item": _vm.item,
      "fieldName": 'vehicle-status'
    },
    slot: "n7"
  })], 1)], 1)]) : _vm._e(), (_vm.$is('quick-booking')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 4
    }
  }, [_c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'vehicle-brand'
    },
    slot: "n1"
  }), _c('div', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": _vm.item.picture_external,
      "width": "100"
    }
  })])]), _c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'vehicle-lot'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'vehicle-plate'
    },
    slot: "n2"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'vehicle-fuel-type'
    },
    slot: "n3"
  }), _c('vehicle-status', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "showToolTip": false
    },
    slot: "n4"
  }), _c('vehicle-additional-status', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "showToolTip": false
    },
    slot: "n4"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        return _vm.$emit('bookVehicle', _vm.item)
      }
    }
  }, [_vm._v("Book")])])], 1)], 1)]) : _vm._e(), (_vm.$is('search-result')) ? _c('div', {
    staticClass: "row vehicle-card-row"
  }, [_c('div', {
    staticClass: "columns small-10 text-center vehicle-card"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "max-width": "12em",
      "margin": "0 auto"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.picture_external
    }
  })]), _c('h2', [_vm._v(_vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), (_vm.item.distance) ? _c('div', {
    staticClass: "distance"
  }, [_c('p', [_vm._v("distance: " + _vm._s(_vm.item.distance) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])]) : _vm._e(), _c('vehicle-fields', {
    staticClass: "vehicle-card-fields",
    attrs: {
      "item": _vm.item,
      "fieldName": 'vehicle-plate'
    }
  }), _c('vehicle-status', {
    staticClass: "vehicle-card-fields",
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "showToolTip": false
    },
    slot: "n4"
  }), _c('vehicle-additional-status', {
    staticClass: "vehicle-card-fields",
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "showToolTip": false
    },
    slot: "n4"
  }), _vm._t("default", [_c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        return _vm.$emit('bookVehicle', _vm.item)
      }
    }
  }, [_vm._v("Book")])])], 2)]) : _vm._e(), (_vm.$is('federationList')) ? _c('div', {
    staticClass: "inner-content federation-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('vehicle-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'vehicle-id'
    }
  }), _c('vehicle-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'vehicle-brand-and-lot'
    }
  })], 1), _c('vehicle-fields', {
    staticClass: "column",
    attrs: {
      "item": _vm.item,
      "fieldName": 'vehicle-category'
    }
  }), _c('vehicle-fields', {
    staticClass: "column",
    attrs: {
      "item": _vm.item,
      "fieldName": 'vehicle-plate'
    }
  }), _c('vehicle-fields', {
    staticClass: "column",
    attrs: {
      "item": _vm.item,
      "fieldName": 'vehicle-lot'
    }
  })], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a7c9ef6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Vehicle.vue
// module id = 2174
// module chunks = 1